import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from './media';
import Title from './title';
import Advertorial from '../../advertorial/advertorial';

export default class Header extends Component {
  shouldComponentUpdate() {
    return false;
  }

  renderAdvertorial() {
    const { advertorial, tags, combinedAdModel } = this.props;

    if (advertorial) {
      return <Advertorial tags={tags} adModel={combinedAdModel} />;
    }

    return null;
  }

  renderDeck() {
    const { post } = this.props;
    const allowedLayouts = ['long', 'hero'];

    if (allowedLayouts.indexOf(post.layout) > -1) {
      return (
        <h2
          className="post__deck"
          dangerouslySetInnerHTML={{ __html: post.excerpt }}
        />
      );
    }

    return null;
  }

  render() {
    const { config, tags, post, isVideoPost, isFirstPost, live } = this.props;

    return (
      <header className="post__header">
        {this.renderAdvertorial()}

        <div className="post__header-text">
          <Title
            config={config}
            isFirstPost={isFirstPost}
            post={post}
            tags={tags}
            live={live}
          />

          {this.renderDeck()}
        </div>

        <Media
          config={config}
          post={post}
          isVideoPost={isVideoPost}
          isFirstPost={isFirstPost}
        />
      </header>
    );
  }
}

Header.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advertorial: PropTypes.bool.isRequired,
  post: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  isFirstPost: PropTypes.bool.isRequired,
  isVideoPost: PropTypes.bool.isRequired,
  live: PropTypes.bool.isRequired
};
